<script setup>

import { ref } from 'vue';

const props = defineProps({
    filter: {
        type: Object,
    },
    filterKey: {
        type: String,
    }
})

const selectedFilters = defineModel('selectedFilters');
const expand = ref(false);

const expandFilter = () => {
    expand.value = !expand.value;
}

</script>

<template>
    <div class="m-locations-media-filter-type">
        <div :class="['m-locations-media-filter-type__box', { 'is-open': expand }]" @click="expandFilter">
            <h2 class="m-locations-media-filter-type__heading heading-sm">
                {{ filterKey }}
            </h2>
            <svg class="icon icon-chevron">
                <use xlink:href="#icon-chevron"></use>
            </svg>
        </div>
        <ul class="m-locations-media-filter-type__list" v-show="expand">
            <li class="m-locations-media-filter-type__item" v-for="(item, index) in filter" :key="index">
                <input type="checkbox" :id="item" :value="item" v-model="selectedFilters[filterKey]" />
                <label :for="item">{{ item }}</label>
            </li>
        </ul>
    </div>
</template>